import React from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { updateCollectorInfo } from "../../store/Collector/collector.action";

const Collector = () => {
  const collectorInfo = useSelector(
    (state) => state.collectorInfo,
    shallowEqual
  );
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    let tempCollectorInfo = [...collectorInfo.collectorInfo];
    if (event.target.name === "collectorContactNumber") {
      tempCollectorInfo[0].collectorContactNumber = event.target.value;
    } else if (event.target.name === "collectorName") {
      tempCollectorInfo[0].collectorName = event.target.value;
    }

    dispatch(updateCollectorInfo(tempCollectorInfo));
  };

  return (
    <div className="row">
      <div className="col-6">
        <input
          type="text"
          step="0.01"
          className="form-control"
          placeholder="Collector Name"
          id="collectorName"
          name="collectorName"
          value={collectorInfo.collectorInfo[0].collectorName}
          onChange={(event) => handleInputChange(event)}
        />
      </div>
      <div className="col-6">
        <input
          type="text"
          step="0.01"
          className="form-control"
          placeholder="Collector Contact Number"
          id="collectorContactNumber"
          name="collectorContactNumber"
          value={collectorInfo.collectorInfo[0].collectorContactNumber}
          onChange={(event) => handleInputChange(event)}
        />
      </div>
    </div>
  );
};

export default Collector;
